import { Language } from '../../settings/i18n/languages';

import { languagesActionTypes } from '.';

export const setLanguage = (language: Language) =>
  ({
    type: languagesActionTypes.SET_LANGUAGE,
    payload: { language },
  } as const);
